export default __webpack_public_path__ + "static/media/Breaking_Down.238ba0c8.svg";